export const CURRIER_TYPES = {
	PICKUP: 'pickup',
	CURRIER: 'currier',
};
